'use strict'

const i18n = require('i18next');
const Backbone = require('backbone');

module.exports = Backbone.Model.extend({
    MAX_NAME_LENGTH: 32,
    kind: 'tag-category',

    /**
     * tag-category のモデル
     *
     * @constructs
     */
    defaults: {
        name: '',
        exposed: false,
        deleted: false
    },

    initialize: function() {
        _.bindAll(this, 'selected', 'select', 'deselect', 'toggle');
        this._selected = false;
    },

    validate: function(attrs) {
        if(attrs.name.length > this.MAX_NAME_LENGTH) {
            return i18n.t('diagram:alert.tag-category.tooLongName', {
                length: this.MAX_NAME_LENGTH
            });
        }
    },

    selected: function() {
        return this._selected;
    },

    select: function() {
        if(!this._selected) {
            this._selected = true;
            this.trigger('selected', this);
            this.trigger('change', this);
        }
    },

    deselect: function() {
        if(this._selected) {
            this._selected = false;
            this.trigger('deselected', this);
            this.trigger('change', this);
        }
    },

    toggle: function() {
        if(this.selected()) {
            this.deselect();
        } else {
            this.select();
        }
    },

    remove: function(opts) {
        this.set({deleted: true}, opts);
    },

    isExposed: function() {
        return this.get('exposed');
    }
});



// WEBPACK FOOTER //
// ./system/domain/entity/tag-category.js